import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA, MatDialogConfig, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { AddAmountSpentComponent } from '../../campaign-dir/add-amount-spent/add-amount-spent.component';
import { AddBudgetComponent } from '../../campaign-dir/add-budget/add-budget.component';
import { AddFeedbackComponent } from '../../campaign-dir/add-feedback/add-feedback.component';
import { AddLeadDeliveredComponent } from '../../campaign-dir/add-lead-delivered/add-lead-delivered.component';
import { AmountSpentListComponent } from '../../campaign-dir/amount-spent-list/amount-spent-list.component';
import { BudgetListComponent } from '../../campaign-dir/budget-list/budget-list.component';
import { CampaignFilterModalComponent } from '../../campaign-dir/campaign-filter-modal/campaign-filter-modal.component';
import { EscalationStatusModalComponent } from '../../campaign-dir/escalation-status-modal/escalation-status-modal.component';
import { FeedbackListModalComponent } from '../../campaign-dir/feedback-list-modal/feedback-list-modal.component';
import { LeadDeliveryListComponent } from '../../campaign-dir/lead-delivery-list/lead-delivery-list.component';
import { RaiseEscalationComponent } from '../../campaign-dir/raise-escalation/raise-escalation.component';
import { SaleCampaignClientCreateModalComponent } from '../../campaign-dir/sale-campaign-client-create-modal/sale-campaign-client-create-modal.component';
import { SaleCampaignProjectCreateModalComponent } from '../../campaign-dir/sale-campaign-project-create-modal/sale-campaign-project-create-modal.component';
import { AssignUserToJobsComponent } from '../../campaign/assign-user-to-jobs/assign-user-to-jobs.component';
import { CampaignJobAttachmentsComponent } from '../../campaign/campaign-job-attachments/campaign-job-attachments.component';
import { CampaignJobLinksComponent } from '../../campaign/campaign-job-links/campaign-job-links.component';
import { CampaignStatusComponent } from '../../campaign/campaign-status/campaign-status.component';
import { CreativeMasterCommentModalComponent } from '../../creative-master/creative-master-comment-modal/creative-master-comment-modal.component';
import { CreativeMasterFilterModalComponent } from '../../creative-master/creative-master-filter-modal/creative-master-filter-modal.component';
import { AscalationCommentModalComponent } from '../../escalation/ascalation-comment-modal/ascalation-comment-modal.component';
import * as saveAs from 'file-saver';
import { CancelledStatusModalComponent } from '../../campaign/cancelled-status-modal/cancelled-status-modal.component';


@Component({
  selector: 'app-drr-master-list',
  templateUrl: './drr-master-list.component.html',
  styleUrls: ['./drr-master-list.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class DrrMasterListComponent implements OnInit {

  authToken: any = localStorage.getItem("token")
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
  showComponentLoader: boolean = false;

  project: any = {
    campaigns: [],
    pagination: {}
  }

  elasticSearch: any = ""
  statusSpinner: boolean = false;


  saleCampaignProjectCreateModalComponent: MatDialogRef<SaleCampaignProjectCreateModalComponent>;

  saleCampaignClientCreateModalComponent: MatDialogRef<SaleCampaignClientCreateModalComponent>
  campaignFilterModalComponent: MatDialogRef<CampaignFilterModalComponent>
  campaignStatusComponent: MatDialogRef<CampaignStatusComponent>;

  addLeadDeliveredComponent: MatDialogRef<AddLeadDeliveredComponent>;
  leadDeliveryListComponent: MatDialogRef<LeadDeliveryListComponent>;

  addBudgetComponent: MatDialogRef<AddBudgetComponent>;
  amountSpentListComponent: MatDialogRef<AmountSpentListComponent>;

  addAmountSpentComponent: MatDialogRef<AddAmountSpentComponent>;
  budgetListComponent: MatDialogRef<BudgetListComponent>;

  addFeedbackComponent: MatDialogRef<AddFeedbackComponent>;
  feedbackListModalComponent: MatDialogRef<FeedbackListModalComponent>;

  raiseEscalationComponent: MatDialogRef<RaiseEscalationComponent>;
  escalationStatusModalComponent: MatDialogRef<EscalationStatusModalComponent>;

  creativeMasterFilterModalComponent: MatDialogRef<CreativeMasterFilterModalComponent>;

  ascalationCommentModalComponent: MatDialogRef<AscalationCommentModalComponent>;

  assignUserToJobsComponent: MatDialogRef<AssignUserToJobsComponent>;

  campaignJobAttachmentsComponent: MatDialogRef<CampaignJobAttachmentsComponent>;

  campaignJobLinksComponent: MatDialogRef<CampaignJobLinksComponent>;

  creativeMasterCommentModalComponent: MatDialogRef<CreativeMasterCommentModalComponent>;

  cancelledStatusModalComponent: MatDialogRef<CancelledStatusModalComponent>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageIndex: number = 0;
  pageSize: number = 100;

  lenCount: any = 0

  url = "";

  createdAt: any;
  selectedClientName: any;
  selectedCampaignType: any;
  selectedStatus: any;
  selectedSalePerson: any;
  selectedAccountManager: any;
  selectedClientType: any;
  selectedProjectType: any;
  selectedAccountType: any;
  selectedSalesterritory: any;
  selectedDealType: any;
  selectedSortBy:any;

  selectedMarketingManager:any;

  allIsActive: boolean = true;

  campaignTypeList: any;
  campaignStatusList: any;
  campaignSalesCityList: any;
  mmList: any;
  clientList: any;
  salePersonList: any;
  marketingList:any;
  // feedbackListModalComponent: MatDialogRef<FeedbackListModalComponent>;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private titleService: Title,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar
  ) {
    // sessionStorage.clear();
    this.showComponentLoader = true
    this.titleService.setTitle('AutomateLeads - Projects');

  }

  ngOnInit() {
    this.allDRRMaster()
    this.getCommon()
    this.getClient()
    this.getSP()
    this.getMM()
    this.getMarketingManager()

  }

  drrList: any;
  allDRRMaster(isFilter?: any) {

    if (isFilter == 'filter') {
      this.allIsActive = false
    }

    let body = {}

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_id"] = this.selectedClientName;
    }

    if (this.selectedCampaignType != undefined && this.selectedCampaignType != "") {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sales_manager_id"] = this.selectedSalePerson;
    }

    if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
      body["account_manager_id"] = this.selectedAccountManager;
    }

    if (this.selectedMarketingManager != undefined && this.selectedMarketingManager != "") {
      body["marketing_manager_id"] = this.selectedMarketingManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (this.selectedProjectType != undefined && this.selectedProjectType != "") {
      body["project_type"] = this.selectedProjectType;
    }

    if (this.selectedAccountType != undefined && this.selectedAccountType != "") {
      body["account_type"] = this.selectedAccountType;
    }

    if (this.selectedSalesterritory != undefined && this.selectedSalesterritory != "") {
      body["sales_city"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    
    if (this.selectedSortBy != undefined && this.selectedSortBy != "") {
      body["sort_by"] = this.selectedSortBy;
    }


    // if ((this.selectedJobCategory != undefined || this.selectedJobCategory != null) && this.selectedJobCategory != "") {
    //   body["job_category"] = this.selectedJobCategory;
    // }


    //console.log(body)

    this.pageIndex = 0;
    this.pageSize = 50;

    this.showComponentLoader = true;

    this.url = "campaign_module/campaign/drr_master?per_page=" + this.pageSize + "&page=" + this.pageIndex;

    this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(
      data => {
        this.project = data;
        //console.log(this.project)
        //this.lenCount = data.creative_jobs.length
        //console.log(this.lenCount)       

        // this.drrList = this.project.campaigns.map(item => {
        //   if (item.mode_of_delivery != '' && item.mode_of_delivery != null && item.mode_of_delivery != undefined) {
        //     console.log(item.mode_of_delivery)
        //     if(item.mode_of_delivery!='' && item.mode_of_delivery!=null && item.mode_of_delivery!=undefined){
        //       return {...item.mode_of_delivery, mode_of_delivery: JSON.parse(item.mode_of_delivery)
        //       };
        //     }
        //   }
        //   });

        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getNext(event) {

    this.showComponentLoader = true

    let body1 = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };

    let body = {}

    this.pageSize = body1.per_page;
    this.pageIndex = body1.page
    let indexPage = this.pageIndex + 1

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_id"] = this.selectedClientName;
    }

    if (this.selectedCampaignType != undefined && this.selectedCampaignType != "") {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sales_manager_id"] = this.selectedSalePerson;
    }

    if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
      body["account_manager_id"] = this.selectedAccountManager;
    }

    if (this.selectedMarketingManager != undefined && this.selectedMarketingManager != "") {
      body["marketing_manager_id"] = this.selectedMarketingManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (this.selectedProjectType != undefined && this.selectedProjectType != "") {
      body["project_type"] = this.selectedProjectType;
    }

    if (this.selectedAccountType != undefined && this.selectedAccountType != "") {
      body["account_type"] = this.selectedAccountType;
    }

    if (this.selectedSalesterritory != undefined && this.selectedSalesterritory != "") {
      body["sales_city"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedSortBy != undefined && this.selectedSortBy != "") {
      body["sort_by"] = this.selectedSortBy;
    }
    

    this.url = "campaign_module/campaign/drr_master?per_page=" + this.pageSize + "&page=" + indexPage;

    this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(data => {
      this.project = data
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  filter(campaignStatus?: any) {

    let body = {};

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_name"] = this.selectedClientName;
    }

    if (this.selectedCampaignType != undefined && this.selectedCampaignType != "") {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sale_person"] = this.selectedSalePerson;
    }

    if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
      body["account_manager"] = this.selectedAccountManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (this.selectedProjectType != undefined && this.selectedProjectType != "") {
      body["project_type"] = this.selectedProjectType;
    }

    if (this.selectedAccountType != undefined && this.selectedAccountType != "") {
      body["account_type"] = this.selectedAccountType;
    }

    if (this.selectedSalesterritory != undefined && this.selectedSalesterritory != "") {
      body["sales_territory"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedSortBy != undefined && this.selectedSortBy != "") {
      body["sort_by"] = this.selectedSortBy;
    }
    
    //console.log(body)

    this.creativeMasterFilterModalComponent = this.dialog.open(CreativeMasterFilterModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: body
    });
    this.creativeMasterFilterModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        // console.log(result)

        this.showComponentLoader = true

        if (result.created_at != undefined && result.created_at != "") {
          this.createdAt = result.created_at
        } else {
          this.createdAt = ""
        }

        if (result.client_name != undefined && result.client_name != "") {
          this.selectedClientName = result.client_name
        } else {
          this.selectedClientName = ""
        }

        if (result.campaign_type != undefined && result.campaign_type != "") {
          this.selectedCampaignType = result.campaign_type
        } else {
          this.selectedCampaignType = ""
        }

        if (result.status != undefined && result.status != "") {
          this.selectedStatus = result.status
        } else {
          this.selectedStatus = ""
        }

        if (result.sales_manager_id != undefined && result.sales_manager_id != "") {
          this.selectedSalePerson = result.sales_manager_id
        } else {
          this.selectedSalePerson = ""
        }

        if (result.account_manager_id != undefined && result.account_manager_id != "") {
          this.selectedAccountManager = result.account_manager_id
        } else {
          this.selectedAccountManager = ""
        }

        if (result.client_type != undefined && result.client_type != "") {
          this.selectedClientType = result.client_type
        } else {
          this.selectedClientType = ""
        }

        if (result.project_type != undefined && result.project_type != "") {
          this.selectedProjectType = result.project_type
        } else {
          this.selectedProjectType = ""
        }

        if (result.account_type != undefined && result.account_type != "") {
          this.selectedAccountType = result.account_type
        } else {
          this.selectedAccountType = ""
        }

        if (result.sales_city != undefined && result.sales_city != "") {
          this.selectedSalesterritory = result.sales_city
        } else {
          this.selectedSalesterritory = ""
        }

        if (result.deal_type != undefined && result.deal_type != "") {
          this.selectedDealType = result.deal_type
        } else {
          this.selectedDealType = ""
        }
        if (result.sort_by != undefined && result.sort_by != "") {
          this.selectedSortBy = result.sort_by
        } else {
          this.selectedSortBy = ""
        }
        
        this.allDRRMaster()
      }
    })
  }



  getClient() {

    this.showComponentLoader = true
    this.serverService.clientsList(this.authToken).subscribe(data => {
      this.clientList = data.client
      this.clientList.unshift({ id: null, name: 'Client Name' })
      //console.log(this.clientList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getSP() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list?user_type=SalesAdmin";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.salePersonList = data.data
      this.salePersonList.unshift({ id: null, name: 'Sales Person' })
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getMM() {

    this.showComponentLoader = true

    let url = "/campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.mmList = data.data
      this.mmList.unshift({ id: null, name: 'Account Manager' })
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }
  getMarketingManager() {

    this.showComponentLoader = true

    let url = "/campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.marketingList = data.data
      this.marketingList.unshift({ id: null, name: 'Marketing Manager' })
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }


  getCommon() {

    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details"

    this.serverService.getEscalationCategory(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.campaignTypeList = data.creative_campaign_type_list;
      this.campaignStatusList = data.campaign_status;
      this.campaignSalesCityList = data.campaign_sales_city_list;
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  openProjectCreateModal(project: any) {
    this.saleCampaignProjectCreateModalComponent = this.dialog.open(SaleCampaignProjectCreateModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '50vw',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.saleCampaignProjectCreateModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  removeSearch() {
    this.elasticSearch = ""
    this.allDRRMaster()
  }

  openClientCreateModal(project) {
    this.saleCampaignClientCreateModalComponent = this.dialog.open(SaleCampaignClientCreateModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.saleCampaignClientCreateModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  updateCampaignStatus(data: any, status) {

    let body = {
      'status': status
      // 'delivery_manager_id': this.project.spAm,
      // 'marketing_manager_id': this.project.spAm,
      // 'client_type': this.project.clientType,  
      // 'client_name': this.project.clientName,
      // 'client_number': this.project.clientEmail,
      // 'city': this.project.city,
      // 'client_rera': this.project.clientRera,  
      // 'project_name': this.project.projectName,
      // 'project_type': this.project.projectType,
      // 'project_address': this.project.location,
      // 'latitude': this.project.latitude,
      // 'longitude': this.project.longitude,  
      // 'min_price': this.project.price,
      // 'project_configuration': this.project.configuration,
      // 'project_status': this.project.projectStatus,  
      // 'possession': this.project.possession,
      // 'rera_number': this.project.reraId,  
      // 'campaign_type': this.project.campaignType,
      // 'duration': this.project.duration,
      // 'no_of_leads': this.project.noOfLeads,  
      // 'mode_of_delivery': this.project,
      // 'mode_of_notification': this.project,  
      // 'offers': this.project,
      // 'media_plan': this.project,  
    }

    this.showComponentLoader = true;
    this.serverService.editSaleCampaign(data.id, body, this.authToken).subscribe(data => {
      // console.log(data);
      this.showComponentLoader = false;
      this.clipBoardService.showMessgeInText('Campaign Update Successfully', 'success-snackbar')
      this.allDRRMaster();
    }, err => {
      this.showComponentLoader = false;
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  goToDetail(data: any) {
    // this.router.navigate([,'_blank'])
    this.router.navigate([]).then(result => { window.open('page/campaign-details/' + data.id, '_blank'); });
  }

  confirmCampaignStatus(campaignId: any, status: any) {

    let statusesandCampaignId = {
      campaignId: campaignId,
      status: status,
    };

    this.campaignStatusComponent = this.dialog.open(CampaignStatusComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      data: statusesandCampaignId,
    });
    this.campaignStatusComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.allDRRMaster();
      }
    });
  }

  openLeadDeliveryModal(project) {
    this.addLeadDeliveredComponent = this.dialog.open(AddLeadDeliveredComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addLeadDeliveredComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openLeadDeliveryListModal(project) {
    this.leadDeliveryListComponent = this.dialog.open(LeadDeliveryListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.leadDeliveryListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openAddAmountSpentModal(project) {
    this.addAmountSpentComponent = this.dialog.open(AddAmountSpentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addAmountSpentComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openSpentListModal(project) {
    this.amountSpentListComponent = this.dialog.open(AmountSpentListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '900px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.amountSpentListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openAddBudgetModal(project) {
    this.addBudgetComponent = this.dialog.open(AddBudgetComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addBudgetComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openAddBudgetListModal(project) {
    this.budgetListComponent = this.dialog.open(BudgetListComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.budgetListComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openAddFeedbackModal(project) {
    this.addFeedbackComponent = this.dialog.open(AddFeedbackComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '80vw',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.addFeedbackComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openFeedbackListModal(project) {
    if(project.derived_data.lead_feedback_qualification.leads_qualified_count){
    this.feedbackListModalComponent = this.dialog.open(FeedbackListModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "90vw",
      maxWidth: "90vw",
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.feedbackListModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }
  }

  openRaiseEscalationModal(project) {
    this.raiseEscalationComponent = this.dialog.open(RaiseEscalationComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.raiseEscalationComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  getStyle(status: string) {

    switch (status) {
      case 'Todo':
        return { 'background-color': '#E3E3E3', 'color': '#454545' };
      case 'In progress':
        return { 'background-color': '#E3E3E3', 'color': '#454545' };
      case 'Awaiting Update':
        return { 'background-color': '#D0E0FF', 'color': '#102348' };
      case 'On Hold':
        return { 'background-color': '#E3E3E3', 'color': '#454545' };
      case 'Done':
        return { 'background-color': 'rgba(87, 211, 87, 0.23)', 'color': '#008000' };
      case 'Cancelled':
        return { 'background-color': 'rgba(255, 247, 246, 1)', 'color': '#8b2a1d', 'border': '1px solid #ab7d7d' };
      default:
        return { 'background-color': '#E3E3E3', 'color': '#454545' };
    }
  }

  statusUpdate(rowData: any) {

    this.showComponentLoader = true;

    if (rowData.status == 'Todo' || rowData.status == 'In progress' || rowData.status == 'Shared For Approval' || rowData.status == 'Awaiting Update' || rowData.status == 'On Hold') {

      let url = 'campaign_module/creative_jobs/' + rowData.id

      const formData: FormData = new FormData();
      formData.append('campaign_id', rowData.campaign_id);
      formData.append('status', rowData.status);

      this.serverService.EStatusUpdateForm(url, formData, this.authToken).subscribe(data => {
        this.clipBoardService.showMessgeInText('Creative Status Updated Successfully', 'success-snackbar')
        this.showComponentLoader = false;
      }, err => {
        this.clipBoardService.checkServerError(err, this.authToken)
        this.showComponentLoader = false;
      }
      )

    }

    if (rowData.status == 'Done') {
      this.openJobAttachmentModal(rowData)
    }

    if(rowData.status.toUpperCase() == "CANCELLED"){
      this.cancelledStatusModal(rowData)
    }

  }


  openJobAttachmentModal(project: any) {
    project['file_type_job'] = 'creative';
    project['job_table_type'] = 'creative_file'
    this.campaignJobAttachmentsComponent = this.dialog.open(CampaignJobAttachmentsComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '700px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.campaignJobAttachmentsComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true

        let url = 'campaign_module/creative_jobs/' + project.id

        const formData: FormData = new FormData();
        formData.append('campaign_id', project.campaign_id);
        formData.append('status', project.status);

        this.serverService.EStatusUpdateForm(url, formData, this.authToken).subscribe(data => {
          this.clipBoardService.showMessgeInText('Creative Status Updated Successfully', 'success-snackbar')
          this.showComponentLoader = false;
        }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
          this.showComponentLoader = false;
        }
        )

        // this.allSaleCampaign()
        this.allDRRMaster();
        //this.timeLine();
      } else {
        this.allDRRMaster();
        this.showComponentLoader = false
      }
    })
  }

  openEscalationUpdateModal(project: any) {
    project['new_status'] = project.status,
      this.escalationStatusModalComponent = this.dialog.open(EscalationStatusModalComponent, {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: '1020px',
        panelClass: 'cdk-overlay-panel-right-side',
        data: project,

      });
    this.escalationStatusModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  openAscalationCommentModal(project) {
    project['commentType'] = 'creative'
    this.creativeMasterCommentModalComponent = this.dialog.open(CreativeMasterCommentModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.creativeMasterCommentModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  sendfeedback(project: any) {
    project['new_status'] = 'feedback',
      project['job_type_feedback'] = 'creative_feedback'
    this.escalationStatusModalComponent = this.dialog.open(EscalationStatusModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '1020px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.escalationStatusModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.allDRRMaster()
      }
    })
  }

  assignUserToJobs(campaign: any) {
    campaign['job_table_type'] = 'escalation';
    this.assignUserToJobsComponent = this.dialog.open(AssignUserToJobsComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      panelClass: "cdk-overlay-panel-right-side",
      data: campaign,
    }
    );
    this.assignUserToJobsComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.allDRRMaster();
      }
    });
  }

  openJobLinksModal(project, job_table_type: any) {
    project['job_table_type'] = job_table_type
    this.campaignJobLinksComponent = this.dialog.open(CampaignJobLinksComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '700px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: project
    });
    this.campaignJobLinksComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        // this.allSaleCampaign()
        this.allDRRMaster();
        //this.timeLine();
      }
    })
  }

  selectCreatedDate(event: any) {
    if (event.formatted != undefined && event.formatted != "" && event.formatted != null) {
      this.createdAt = event
      this.allDRRMaster('filter')
    } else {
      this.createdAt = undefined;
      this.allDRRMaster('filter')
    }
  }


  resetFilter() {
    this.createdAt = null;
    this.selectedClientName = null;
    this.selectedCampaignType = null;
    this.selectedStatus = null;
    this.selectedSalePerson = null;
    this.selectedAccountManager = null;
    this.selectedMarketingManager= null;
    this.selectedClientType = null;
    this.selectedProjectType = null;
    this.selectedAccountType = null;
    this.selectedSalesterritory = null;
    this.selectedDealType = null;
    this.selectedSortBy = null;
    this.allDRRMaster()
    this.allIsActive = true;
  }
  navToCampaign(item: any) {
    this.router.navigate([]).then(result => { window.open('page/campaign-details/' + item.id, '_blank'); });
  }

  exportDetails() {
    this.statusSpinner = true
    let body = {"export": true}

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_id"] = this.selectedClientName;
    }

    if (this.selectedCampaignType != undefined && this.selectedCampaignType != "") {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sales_manager_id"] = this.selectedSalePerson;
    }

    if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
      body["account_manager_id"] = this.selectedAccountManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (this.selectedProjectType != undefined && this.selectedProjectType != "") {
      body["project_type"] = this.selectedProjectType;
    }

    if (this.selectedAccountType != undefined && this.selectedAccountType != "") {
      body["account_type"] = this.selectedAccountType;
    }

    if (this.selectedSalesterritory != undefined && this.selectedSalesterritory != "") {
      body["sales_city"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedSortBy != undefined && this.selectedSortBy != "") {
      body["sort_by"] = this.selectedSortBy;
    }
    let url = 'campaign_module/campaign/drr_master'
    
    this.serverService.exportCampaignDetails(url, body, this.authToken).subscribe((data) => {
      //saveAs(new Blob([data.body], { type: 'application/xlsx' }), 'campaign_drr_report' + '.xlsx')
      saveAs(new Blob([data.body], { type: 'text/csv' }), 'campaign_drr_report' + '.csv')
      this.statusSpinner = false
    },
    (err: any) => {  
      console.error('Error exporting DRR:', err);
      this.statusSpinner = false;
    }
  )
  }


  cancelledStatusModal(element:any){  
    // project['file_type_job'] = file_type;
    // project['job_table_type'] = job_table_type
    this.cancelledStatusModalComponent = this.dialog.open(CancelledStatusModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: 'blue-snackbar',
        data: element,
      }
    );
    this.cancelledStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true

        let url = '/campaign_module/creative_jobs/' + element.id

        const formData: FormData = new FormData();
        formData.append('campaign_id', element.campaign_id);
        formData.append('status', element.status);

        this.serverService.EStatusUpdateForm(url, formData, this.authToken).subscribe(data => {
          this.clipBoardService.showMessgeInText('Creative Status Updated Successfully', 'success-snackbar')
          this.showComponentLoader = false;
        }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
          this.showComponentLoader = false;
        }
        )
        this.allDRRMaster();
      } else {
        this.allDRRMaster();
        this.showComponentLoader = false
      }
    });
  }
  // openFeedbackListModal(project) {
  //   // if (
  //   //   this.campaignStats != null &&
  //   //   this.campaignStats.latest_feedback_analysis != null
  //   // ) {
  //     this.feedbackListModalComponent = this.dialog.open(
  //       FeedbackListModalComponent,
  //       {
  //         hasBackdrop: true,
  //         disableClose: false,
  //         autoFocus: true,
  //         width: "1020px",
  //         panelClass: "cdk-overlay-panel-right-side",
  //         data: project,
  //       }
  //     );
  //   }
  // }
}